module.exports = __webpack_public_path__ + "static/img/active1.50542ea5.jpg";